// extracted by mini-css-extract-plugin
export default {"imageWrapper":"uG-z","twoColumnImage":"vG-z"};